module.exports = __webpack_public_path__ + "static/media/reject.7b3e3696.svg";